import { Controller, Control } from "react-hook-form";
import { SelectField } from "../../ui";
export enum UnitOfMeasureEnum {
  LINEAR_METER = 'meter',            // Tubulação, rodapé, eletroduto
  SQUARE_METER = 'square_meter',     // Revestimento, pintura, alvenaria
  CUBIC_METER = 'cubic_meter',       // Concreto, escavação, aterro
  KILOGRAM = 'kilogram',             // Aço, argamassa, produtos químicos
  TON = 'ton',                       // Aço estrutural, entulho
  BAG = 'bag',                       // Cimento, cal, argamassa
  LITER = 'liter',                   // Tintas, solventes
  UNIT = 'unit',                     // Peças, portas, louças
  SET = 'set',                       // Kits, conjuntos montados
  PACKAGE = 'package',               // Materiais embalados
  HOUR = 'hour',                     // Mão de obra técnica
  DAY = 'day',                       // Diária de pedreiro, servente
  MONTH = 'month',                   // Administração, aluguel mensal
  ALLOWANCE = 'allowance',           // Custos não mensuráveis (VB)
  SERVICE = 'service'                // Serviço fechado
}


interface SelectUnitOfMeasureProps {
  name: string;
  control: Control<any>;
  label?: string;
  disabled?: boolean;
}

const unitOfMeasureOptions = [
  { value: UnitOfMeasureEnum.LINEAR_METER, label: "Metro Linear" },
  { value: UnitOfMeasureEnum.SQUARE_METER, label: "Metro Quadrado" },
  { value: UnitOfMeasureEnum.CUBIC_METER, label: "Metro Cúbico" },
  { value: UnitOfMeasureEnum.KILOGRAM, label: "Quilograma" },
  { value: UnitOfMeasureEnum.TON, label: "Tonelada" },
  { value: UnitOfMeasureEnum.BAG, label: "Saco" },
  { value: UnitOfMeasureEnum.LITER, label: "Litro" },
  { value: UnitOfMeasureEnum.UNIT, label: "Unidade" },
  { value: UnitOfMeasureEnum.SET, label: "Conjunto" },
  { value: UnitOfMeasureEnum.PACKAGE, label: "Pacote" },
  { value: UnitOfMeasureEnum.HOUR, label: "Hora" },
  { value: UnitOfMeasureEnum.DAY, label: "Dia(s)" },
  { value: UnitOfMeasureEnum.MONTH, label: "Mês" },
  { value: UnitOfMeasureEnum.ALLOWANCE, label: "Verba" },
  { value: UnitOfMeasureEnum.SERVICE, label: "Serviço" },
];

export function SelectUnitOfMeasure({ name, control, label, disabled }: SelectUnitOfMeasureProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <SelectField
          {...field}
          label={label || "Unidade de Medida"}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          disabled={disabled}
        >
          {unitOfMeasureOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </SelectField>
      )}
    />
  );
}
